import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormInputSearch,
  title: 'Search',
  category: ComponentCategory.FormControls,
};
